export const valleedurichelieu = {
  logo_image_url: 'valleedurichelieu.png',
  logo_height: 70,

  token_margin_left: 10,
  token_url: 'valleedurichelieu.png',
  token_width: 60,

  number_hidden: true,

  button_color: '#DF4661',
  button_font: 'Rubik, sans-serif',
  button_half_border_color: '#090204',

  text_font: `Rubik, sans-serif`,
  title_font: `Rubik, sans-serif`,
}

export const valleedurichelieu_bestiaire = {
  ...valleedurichelieu,
  token_url: 'valleedurichelieu/bestiaire.png',
  number_hidden: true,
}

export const valleedurichelieu_borne = {
  ...valleedurichelieu,
  token_url: 'valleedurichelieu/borne.png',
  token_margin_left: -3,
  number_hidden: true,
}

export const valleedurichelieu_rallye = {
  ...valleedurichelieu,
  token_url: 'valleedurichelieu/rallye.png',
  number_hidden: true,
}
